module.exports = __webpack_public_path__ + "media/images/logo-dark-a9cb99d6a2608490d67bb2bd0bb0dbee.png";